import { Alert, Typography } from "@mui/material"
import { WarningOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import { toAccountsPayableBalanceSummary } from "../../utils/accountsPayableFormat"

import { classNames } from "@/utils/utils"

interface AccountsPayableBalanceBannerProps {
  balance?: number
  error?: string
}

export const AccountsPayableBalanceBanner: FC<AccountsPayableBalanceBannerProps> = ({ balance, error }) => {
  if (error) {
    return (
      <Alert severity='error' variant='outlined' className='px-6 py-4' data-testid='accounts-payable.balance-error'>
        <Typography variant='subtitle1'>{error}</Typography>
      </Alert>
    )
  }

  if (balance === undefined) return null

  const { amountLabel, asOfLabel, isDueFromVendor } = toAccountsPayableBalanceSummary(balance)

  return (
    <Alert
      severity='warning'
      variant='filled'
      className='px-6 py-4'
      icon={<WarningOutlined className='p-0' />}
      data-testid='accounts-payable.balance-banner'
    >
      <Typography variant='subtitle1' className='tracking-[0.0083em]'>
        <strong className={classNames({ "text-secondary-600": isDueFromVendor })}>{amountLabel}</strong>
        {` as of ${asOfLabel}`}
      </Typography>
    </Alert>
  )
}
